module.exports = __webpack_public_path__ + "img/12f6cd2.jpg";